import { Star } from "lucide-react";
import { cn } from "@/lib/utils";

export function formatScore(score: number) {
  return score.toFixed(1).replace(".", ",");
}

/** Nota da comunidade em formato compacto (cards, listas). */
export function ScorePill({
  score,
  raters,
  className,
}: {
  score: number | null;
  raters?: number;
  className?: string;
}) {
  if (score == null) return null;
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full border border-amber-400/30 bg-amber-400/10 px-1.5 py-0.5 text-[11px] font-bold tabular-nums text-amber-300",
        className,
      )}
      title={raters ? `${raters} ${raters === 1 ? "pessoa avaliou" : "pessoas avaliaram"}` : undefined}
    >
      <Star className="h-3 w-3 fill-current" strokeWidth={0} />
      {formatScore(score)}
    </span>
  );
}
